var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 140,
    viewBox: "0 0 180 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.0441 76.777C51.0441 76.777 49.7817 54.3209 60.7636 51.2133C71.7454 48.1056 86.4235 79.8113 60.6774 91L51.0441 76.777Z",
    fill: "#F4A28C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M51.0441 76.777C51.0441 76.777 49.7817 54.3209 60.7636 51.2133C71.7454 48.1056 86.4235 79.8113 60.6774 91L51.0441 76.777Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.469 11.5278L58.5 19.4785L68.0218 102.228L136.991 94.2774L127.469 11.5278Z",
    fill: "#BABABA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.033 9.44522L58.0078 17.1719L67.5296 99.9215L134.555 92.1948L125.033 9.44522Z",
    fill: "#CCCCCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M89.5 129C126.779 129 157 103.928 157 73C157 42.0721 126.779 17 89.5 17C52.2208 17 22 42.0721 22 73C22 103.928 52.2208 129 89.5 129Z",
    fill: "#E6E6E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.338 7.51163L55.3125 15.2383L64.8343 97.9879L131.86 90.2612L122.338 7.51163Z",
    fill: "#E6E6E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9587 18.6409L63.4609 21.2344L66.4604 47.3016L88.9582 44.7081L85.9587 18.6409Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43.3749C67 43.3749 67.6619 37.5895 72.6794 35.3817C77.6968 33.1739 84.8415 32.7495 88.4947 40.7535L89 45.3678L67.5053 48L67 43.3749Z",
    fill: "#0D9F3F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4408 27L74 33.9848L78 36L76.4501 28.8939L74.4408 27Z",
    fill: "#F4A28C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M76.5556 30.5252C75.9747 30.4605 75.4338 30.2779 75 30C75.2805 30.8198 75.9953 31.5346 77 32L76.5556 30.5252Z",
    fill: "#CE8172"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4496 25.5546C77.7692 26.917 77.9543 28.332 78 29.7619C77.9949 29.933 77.965 30.1011 77.9121 30.2563C77.8592 30.4115 77.7842 30.5506 77.6917 30.6657C77.5991 30.7807 77.4908 30.8693 77.3731 30.9264C77.2553 30.9834 77.1304 31.0077 77.0058 30.9979C76.605 31.0151 76.209 30.8739 75.8651 30.5911C75.5212 30.3083 75.2439 29.8957 75.0661 29.4026L74.1695 27.3812C74.0168 26.9506 73.9655 26.4654 74.0228 25.9931C74.08 25.5207 74.243 25.0844 74.4891 24.7448C75.3502 23.3992 77.1434 24.002 77.4496 25.5546Z",
    fill: "#F4A28C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0927 27L77.8702 28.2707C77.9178 28.3411 77.9545 28.4337 77.9765 28.539C77.9986 28.6442 78.0053 28.7584 77.9959 28.87C77.9864 28.9816 77.9613 29.0866 77.9229 29.1743C77.8846 29.262 77.8344 29.3293 77.7775 29.3694L77 30L77.0927 27Z",
    fill: "#F4A28C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0381 30L73.1412 26.9861C73.1412 26.9861 71.7332 26.8789 72.0451 25.6428C72.3571 24.4068 72.9809 25.0784 72.8856 23.7521C72.7903 22.4258 73.6092 22.0025 74.272 22.6741C74.9349 23.3457 74.5666 22.3298 75.2988 22.0758C76.031 21.8218 76.265 22.2282 76.343 22.9619C76.421 23.6957 77.4304 22.7587 77.7857 23.6505C78.141 24.5423 78.2666 25.4227 76.421 25.8573C74.5753 26.2919 76.1004 28.0528 74.0381 30Z",
    fill: "#FFD200"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M76 28.9569C76 28.9569 75.8209 27.7424 75.2834 28.0499C74.746 28.3573 75.0078 30.1099 75.7749 29.9946L76 28.9569Z",
    fill: "#F4A28C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M67 42.31C67 42.31 69.4473 47.4483 74.5845 43.7724C79.7217 40.0965 85.4707 38.1555 88.7978 42.443L89 44.7429L67.4905 48L67 42.31Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M107.768 16.9142L91.1484 18.8301L91.5937 22.6997L108.214 20.7838L107.768 16.9142Z",
    fill: "#BABABA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M108.628 24.4356L92.0078 26.3516L92.4531 30.2212L109.073 28.3052L108.628 24.4356Z",
    fill: "#BABABA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M89.521 49.5396L74.7344 51.2441L75.1796 55.1137L89.9663 53.4092L89.521 49.5396Z",
    fill: "#BABABA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M90.8257 60.9614L76.0391 62.666L76.4843 66.5356L91.271 64.831L90.8257 60.9614Z",
    fill: "#BABABA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M117.99 46.2544L103.203 47.959L103.648 51.8286L118.435 50.124L117.99 46.2544Z",
    fill: "#BABABA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M119.302 57.6821L104.516 59.3867L104.961 63.2563L119.748 61.5517L119.302 57.6821Z",
    fill: "#BABABA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M118.251 30.9477L92.875 33.873L94.0541 44.1201L119.43 41.1948L118.251 30.9477Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M122.531 68.147L69.6406 74.2441L71.3382 88.997L124.229 82.8999L122.531 68.147Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2586 50.7909L66.9375 51.4043L67.5503 56.7303L72.8714 56.1168L72.2586 50.7909Z",
    fill: "#0D9F3F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M100.352 47.5546L95.0312 48.168L95.6441 53.4939L100.965 52.8805L100.352 47.5546Z",
    fill: "#FFD200"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5711 62.2147L68.25 62.8281L68.8628 68.1541L74.1839 67.5407L73.5711 62.2147Z",
    fill: "#24285B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M101.673 58.9764L96.3516 59.5898L96.9644 64.9158L102.285 64.3024L101.673 58.9764Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M123.65 77.5794L107.719 79.416L108.332 84.742L124.263 82.9054L123.65 77.5794Z",
    fill: "#0D9F3F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M70.0082 58C70.0082 58 75.2686 61.2919 71.3904 68.3824C67.5123 75.473 71.8717 80.9257 72.8175 83.0865C73.7632 85.2472 75 101.029 75 101.029L66.4266 102L62 85.514L63.8523 68.9L70.0082 58Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M109.199 8.8581L109.024 7.70596C108.912 6.83002 109.197 5.95058 109.818 5.26016C110.439 4.56975 111.344 4.12462 112.335 4.02222V4.02222C112.826 3.97182 113.324 4.00736 113.799 4.12682C114.275 4.24627 114.719 4.44729 115.106 4.71838C115.494 4.98948 115.817 5.32533 116.057 5.70676C116.297 6.08818 116.45 6.50769 116.507 6.94131L117.981 18.2664C118.024 18.5863 117.994 18.9106 117.894 19.2204C117.795 19.5303 117.627 19.8198 117.4 20.0722C117.173 20.3247 116.892 20.5352 116.574 20.6916C116.255 20.8481 115.904 20.9474 115.541 20.984V20.984C114.81 21.0581 114.075 20.8729 113.498 20.469C112.921 20.065 112.549 19.4754 112.464 18.8295L111.668 12.733",
    stroke: "#24285B",
    strokeWidth: 2.03,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7576 66.5677C57.7576 66.5677 63.9752 55.2447 67.9493 55.0044C71.2135 54.8112 72.8975 61.0002 67.5711 68.0144C66.4875 69.4267 65.7173 71.0569 65.3124 72.795C64.9075 74.533 64.8773 76.3384 65.2239 78.0892C65.8198 81.0245 65.8042 84.717 63.6073 88.1066C58.9856 95.2357 53.1669 91.7626 51.7628 84.2313C50.3586 76.7 50.1566 74.4228 57.7576 66.5677Z",
    fill: "#F4A28C"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1417 92L75 133.715L46 136L46.9781 93.0806L70.1417 92Z",
    fill: "#24285B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M51 94V87H70V92.8437L51 94Z",
    fill: "#0D9F3F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M51 94V87H70V92.8437L51 94Z",
    fill: "#0D9F3F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M61 87L62.2689 135L75 133.985L70.1741 92.0752H68.9795V87H61Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalData);
export default __webpack_public_path__ + "static/media/personal_data.a19eeb27fc1e64bd495a59dd06b41430.svg";
export { ForwardRef as ReactComponent };